var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('j-editable-table',{attrs:{"columns":_vm.columns,"dataSource":_vm.dataSource,"rowNumber":true,"actionButton":true,"rowSelection":true,"maxHeight":400},on:{"valueChange":_vm.handleValueChange}})}
var staticRenderFns = []

export { render, staticRenderFns }